import DirectusImage from '@/src/components/common/DirectusImage'
import styles from './AGLogo.module.scss'
import { AnchorHTMLAttributes, useContext } from 'react'
import { DirectusContext } from '@/src/contexts/DirectusContext'
import { classNames } from '@/src/helpers/component'
import Link from 'next/link'

export default function AGLogoClient(_: AnchorHTMLAttributes<HTMLAnchorElement>) {
  const directusContext = useContext(DirectusContext)

  return (
    <Link href={'/'} {..._}>
      <DirectusImage
        className={classNames(styles.logo, '--topnav-logo')}
        directusFile={directusContext.SITE_SETTINGS.site_logo}
        loading={'eager'}
      />
    </Link>
  )
}
